import { RequestType } from '@app/v2/enums/request-types.enum';

export enum NoteCardContext {
    Site = 'Site',
    Patient = 'Patient',
    Travel = RequestType.Travel,
    Stipend = RequestType.Stipend,
    Reimbursement = RequestType.Reimbursement,
}
